import React, { Component } from 'react';
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    CustomInput,
    Spinner,
    Row,
    Col
} from 'reactstrap';
import Toast from '../common/custom-controls/Toast';
import { subscriberService } from '../../services/subscriber-service';
import packageService from '../../services/PackageService';

const DAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

class CustomSubscriptionByMobile extends Component {

    state = {
        mobile: '',
        customerId: null,

        packages: [],
        selectedPackageId: '',

        count: 1,
        selectedDays: [],
        loading: false,

        toast: {
            type: '',
            message: ''
        }
    };

    componentDidMount() {
        this.loadPackages();
    }

    loadPackages = () => {
        packageService.getPackages()
            .then(res => {
                const activePackages = (res || []).filter(pkg => pkg.isActive);
                this.setState({ packages: activePackages });
            })
            .catch(() => {
                this.setToast('warning', 'Failed to load packages');
            });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };


    toggleDay = (day) => {
        this.setState(prev => ({
            selectedDays: prev.selectedDays.includes(day)
                ? prev.selectedDays.filter(d => d !== day)
                : [...prev.selectedDays, day]
        }));
    };


    findSubscriber = () => {
        const { mobile } = this.state;

        if (!mobile) {
            return this.setToast('warning', 'Please enter mobile number');
        }

        this.setState({ loading: true });

        subscriberService.getSubscribersByMobile(mobile)
            .then(res => {
                if (res?.data?.id) {
                    this.setState({
                        customerId: res.data.id,
                        loading: false
                    });
                } else {
                    this.setToast('warning', 'Subscriber not found');
                }
            })
            .catch(() => this.setToast('warning', 'Subscriber not found'));
    };

    handleSubmit = () => {
        const {
            customerId,
            selectedPackageId,
            selectedDays,
            count
        } = this.state;

        if (!customerId) {
            return this.setToast('warning', 'Please find subscriber first');
        }

        if (!selectedPackageId) {
            return this.setToast('warning', 'Please select a package');
        }

        if (!selectedDays.length) {
            return this.setToast('warning', 'Select at least one day');
        }

        const payload = {
            packageId: Number(selectedPackageId),
            count: Number(count),
            paymentMethod: 'MOBILE',
            source: 'WEB',
            salesType: 'SUBSCRIPTION',
            isCompartmentCharge: 0,
            customerId,
            txnId: crypto.randomUUID(),
            subscriptionType: 'CUSTOM_DAYS',
            days: selectedDays
        };

        this.setState({ loading: true });

        subscriberService.subscribeCustomDays(payload)
            .then(res => {
                if (res?.data?.alreadySubscribed) {
                    return this.setToast('warning','Subscriber already subscribed.');
                }

                this.setToast('success', 'Customize subscription added successfully');
                this.resetForm();
            })
            .catch(err => {
                this.setToast(
                    'warning',
                    err?.response?.data?.message || 'Subscription failed'
                );
            });
    };

    resetForm = () => {
        this.setState({
            mobile: '',
            customerId: null,
            selectedPackageId: '',
            count: 1,
            selectedDays: [],
            loading: false
        });
    };

    setToast = (type, message) => {
        this.setState({
            loading: false,
            toast: { type, message }
        });
    };

    render() {
        const {
            mobile,
            customerId,
            packages,
            selectedPackageId,
            count,
            selectedDays,
            loading,
            toast
        } = this.state;

        return (
            <div>
                <h5 className="mb-3">Custom Subscription</h5>

                <Toast
                    isOpen={!!toast.message}
                    type={toast.type}
                    message={toast.message}
                    handleOnClose={() =>
                        this.setState({ toast: { type: '', message: '' } })
                    }
                />

                <Form>
                    {/* Mobile */}
                    <FormGroup>
                        <Label>Mobile Number</Label>
                        <Row>
                            <Col md={4}>
                                <Input
                                    type="tel"
                                    name="mobile"
                                    value={mobile}
                                    maxLength="11"
                                    onChange={this.handleChange}
                                    placeholder="07XXXXXXXX"
                                />
                            </Col>
                            <Col md="auto">
                                <Button
                                    color="primary"
                                    onClick={this.findSubscriber}
                                    disabled={loading}
                                >
                                    {loading ? <Spinner size="sm" /> : 'Find Subscriber'}
                                </Button>
                            </Col>
                        </Row>
                    </FormGroup>

                    {customerId && (
                        <>
                            {/* Package */}
                            <FormGroup>
                                <Label>Package</Label>
                                <Row>
                                    <Col md={5}>
                                        <Input
                                            type="select"
                                            name="selectedPackageId"
                                            value={selectedPackageId}
                                            onChange={this.handleChange}
                                        >
                                            <option value="">-- Select Package --</option>
                                            {packages.map(pkg => (
                                                <option key={pkg.id} value={pkg.id}>
                                                    {pkg.packageName}
                                                </option>
                                            ))}
                                        </Input>
                                    </Col>
                                </Row>
                            </FormGroup>

                            {/* Count */}
                            <FormGroup>
                                <Label>Count</Label>
                                <Row>
                                    <Col md={2}>
                                        <Input
                                            type="number"
                                            name="count"
                                            min="1"
                                            value={count}
                                            onChange={this.handleChange}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Label>Select Days</Label>
                                {DAYS.map(day => (
                                    <CustomInput
                                        key={day}
                                        type="checkbox"
                                        id={day}
                                        label={day}
                                        checked={selectedDays.includes(day)}
                                        onChange={() => this.toggleDay(day)}
                                    />
                                ))}
                            </FormGroup>

                            <Button
                                color="success"
                                onClick={this.handleSubmit}
                                disabled={loading}
                            >
                                {loading ? <Spinner size="sm" /> : 'Subscribe'}
                            </Button>
                        </>
                    )}
                </Form>
            </div>
        );
    }
}

export default CustomSubscriptionByMobile;
